import { Suspense } from "react";

import { graphql, useLazyLoadQuery } from "react-relay";

import { SettingsTabsLayout } from "../SettingsTabsLayout";
import { type IdentityProvidersSettingsRootQuery } from "./__generated__/IdentityProvidersSettingsRootQuery.graphql";
import { AccessControlSettingsPage } from "./AccessControlSettingsPage";
import { IdentityProviders } from "./IdentityProviders/IdentityProviders";
import { IdentityProvidersActionBar } from "./IdentityProvidersActionBar";

export function IdentityProvidersSettingsRoot() {
  const data = useLazyLoadQuery<IdentityProvidersSettingsRootQuery>(
    graphql`
      query IdentityProvidersSettingsRootQuery {
        ...AccessControlSettingsPage_query
        ...IdentityProviders_query
      }
    `,
    {},
  );

  return (
    <AccessControlSettingsPage pageTitle="Identity Providers" queryRef={data}>
      <SettingsTabsLayout>
        <div className="flex w-full flex-col">
          <IdentityProvidersActionBar />

          <Suspense fallback={null}>
            <IdentityProviders queryRef={data} />
          </Suspense>
        </div>
      </SettingsTabsLayout>
    </AccessControlSettingsPage>
  );
}
